/*!
 * devextreme-angular
 * Version: 22.2.5
 * Build date: Mon Mar 27 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */

/* tslint:disable:use-input-property-decorator */

import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf
} from '@angular/core';





import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { DxoSortableOptions } from './base/sortable-options';


@Component({
    selector: 'dxo-item-dragging',
    template: '',
    styles: [''],
    providers: [NestedOptionHost],
    inputs: [
        'allowDropInsideItem',
        'allowReordering',
        'autoScroll',
        'boundary',
        'container',
        'cursorOffset',
        'data',
        'dragDirection',
        'dragTemplate',
        'dropFeedbackMode',
        'elementAttr',
        'filter',
        'group',
        'handle',
        'height',
        'itemOrientation',
        'moveItemOnDrop',
        'onAdd',
        'onDisposing',
        'onDragChange',
        'onDragEnd',
        'onDragMove',
        'onDragStart',
        'onInitialized',
        'onOptionChanged',
        'onRemove',
        'onReorder',
        'rtlEnabled',
        'scrollSensitivity',
        'scrollSpeed',
        'width'
    ]
})
export class DxoItemDraggingComponent extends DxoSortableOptions implements OnDestroy, OnInit  {

    protected get _optionPath() {
        return 'itemDragging';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoItemDraggingComponent
  ],
  exports: [
    DxoItemDraggingComponent
  ],
})
export class DxoItemDraggingModule { }
